module.exports = __webpack_public_path__ + "img/2_2-finanziario-filiale-2.0fa25d11.png";